<div class="hidewhenloading" #hidewhenloading>
  <div class="d-flex flex-column flex-lg-row justify-content-center">
    <div class="module-overview mw-100 mx-auto ml-lg-0 mr-lg-5">
      <img src="{{package.imageUrl}}" alt="Banner image for {{this.headerinfo.headerDisplay.maintitle}}" class="w-100 bg-black-100 object-cover object-center mb-3 rounded shadow-sm-darker">
      <div [innerHTML]="package.description" class="innerHTML-wrap"></div>
      <button *ngIf="!currentUserIsAdmin && !currentUserIsStudent && !notauser" (click)="enroll()" class="btn mx-auto mt-4">Enrol For Package</button>
    </div>
    <div class="module-pricing-aside text-center flex-shrink-0 mx-auto mx-lg-0">
      <section class="mt-5 mt-lg-0">
        <h3 class="mb-0">Package Price</h3>
        <p class="mb-0 font-weight-600">
          <span class="text-2xl2 text-gradient-primary">{{package.amountPerStudent ? ('₦' + this.formatNumber(package.amountPerStudent)) : 'Free'}}</span>
          <br>
          For
          <br>
          <span class="text-2xl2 text-gradient-primary">{{package.accessdays || 'Unlimited'}}</span>
          <br>
          Day{{package.accessdays !== 1 ? 's' : ''}} Access
        </p>
      </section>
    </div>
  </div>
  <section class="curriculum mw-100 mt-5">
    <h3 class="mb-4 text-center text-lg-left">Courses</h3>
    <div *ngIf="(!modules || modules.length === 0) && currentUserIsAdmin" class="p-4 rounded shadow-sm-darker">
      <button (click)="showAddCourseModal()" class="btn"><i class="fa fa-plus"></i> Add The First Course </button>
    </div>
    <app-modules  [modules]="modules" [inPackage]="true" [currentUserIsAdmin]="currentUserIsAdmin" (deleteClicked)="deletePackageModuleClicked($event)"></app-modules>
    <!-- <app-modules #modulesComponent [modulesURL]="" [modulesPerPage]="6"></app-modules> -->
  </section>
</div>

  <div class="modal fade" id="deletePackage" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Delete Package</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-0">
          <p class="text-center pb-2">Are you sure you want to delete this package?</p>
          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button type="submit" class="btn btn--danger m-0" (click)="deletePackage()">Delete</button>
            <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="selectCourseDialog" data-keyboard="false" aria-hidden="true" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Select Course</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form #addCourseForm="ngForm" (ngSubmit)="addCourse()" class="mb-0">
            <div class="fieldset fieldset--lg">
              <label class="legend" for="newModuleId">Course <span class="requiredfield">*</span></label>
              <!-- <select #newModuleIdField [(ngModel)]="newModuleId" name="newModuleId" required class="text-field" id="newModuleId">
                <option *ngFor="let module of modulesnotinpackage" value="{{module.id}}">{{(module.courseCode ? module.courseCode + ' - ' : '')}}{{module.courseTitle}}</option>
              </select> -->
              <ng-select #newModuleIdField [(ngModel)]="newModuleId" name="newModelId" required ngDefaultControl>
                <ng-option *ngFor="let module of modulesnotinpackage" [value]="module.id">{{(module.courseCode ? module.courseCode + ' - ' : '')}}{{module.courseTitle}}</ng-option>
             </ng-select>
            </div>
            <div class="d-flex justify-content-center flex-wrap gap-1.5">
              <button class="btn m-0" [disabled]="!addCourseForm.form.valid" type="submit"> Save </button>
              <button class="btn btn--warning m-0" (click)="closeSelectCourseDialog()"> Cancel </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="deletePackageModule" data-keyboard="false" aria-hidden="true" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Remove Course from Package</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-0">
          <p class="text-center pb-2">Are you sure you want to remove this course?</p>
          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button type="submit" class="btn btn--danger m-0" (click)="deletePackageModule()">Remove</button>
            <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- <div class="modal fade" id="paymentDialog" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <iframe sandbox="allow-scripts allow-forms allow-modals allow-popups allow-same-origin" #paymentIframe class="payment-iframe"></iframe>
        </div>
      </div>
    </div>
  </div> -->
  
  <!--
  <div class="modal fade" #enrolstudents id="enrolstudents" aria-hidden="true" aria-labelledby="enrolstudents" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Enrol Students for Course</h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p><a href="../../assets/templates/CourseStudentEnrollTemplate.xlsx" class="text-link text-xs"><i class="fa fa-info-circle"></i> Download Template</a></p>
          <form #uploadform="ngForm" (ngSubmit)="enrolstudent(files.files)" name="uploadform">
            <p class="text-center text-sm">{{enrolFileName || 'No File Selected'}}</p>
            <button (click)="files.click()" type="button" id="filesLabel" class="btn btn--dashed m-auto">Select File</button>
            <input #files (change)="enrolFileName = files.files[0]?.name" type="file" name="files" accept=".xls,.xlsx" aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
            <div class="d-flex justify-content-around flex-wrap gap-1.5 mt-5">
              <button type="submit" class="btn m-0" [disabled]="files.files.length < 1">Upload</button>
              <button type="button" class="btn btn--warning m-0" (click)="closeEnrolModal()">Close</button>
            </div>
          </form>
        </div>
      </div>
    </div> 
  </div>-->
  